import Amplify, { Auth, Hub } from "aws-amplify";

Amplify.configure({
  // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
  Auth: {
    identityPoolId: process.env.REACT_APP_COGNITO_identityPoolId,

    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_COGNITO_region,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_COGNITO_userPoolId,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_COGNITO_userPoolWebClientId,
  },

  //   // OPTIONAL - Hosted UI configuration
  oauth: {
    domain: process.env.REACT_APP_COGNITO_DOMAIN,
    scope: [
      "phone",
      "email",
      "profile",
      "openid",
      "aws.cognito.signin.user.admin",
    ],

    redirectSignIn: `${process.env.REACT_APP_MY_URL}/auth`,
    redirectSignOut: `${process.env.REACT_APP_MY_URL}/`,

    responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
  },
});

export { Auth, Hub };
